export const DEGREE_TITLES = [
    'Unknown',
    'Certificate',
    'B.A.',
    'BArch',
    'BFA',
    'B.Sc.',
    'M.A.',
    'M.B.A.',
    'MFA',
    'M.Sc.',
    'J.D.',
    'M.D.',
    'Ph.D',
    'LLB',
    'LLM',
    'Associate',
    'BM',
    'Other'
];
